"use client";
import CheckBadgeIcon from "@heroicons/react/24/solid/CheckBadgeIcon";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import { Button } from "@/components/ui/button";

export default function EndingPart({ onClose }: any) {
  return (
    <div className="flex flex-col gap-4 pt-4 pb-6">
      <div className="py-[43px] w-full justify-between flex flex-wrap items-center">
        <span className="md:max-w-[351px] text-sm font-bold text-[#15bbae]">
          Profil onayınız site yönetimine gönderilmiştir.
        </span>

        <CheckBadgeIcon className="text-[#15bbae] size-[72px]" />
      </div>

      <Button
        type="button"
        onClick={() => onClose()}
        className="w-full py-3 px-2 bg-transparent font-bold text-sm border-assistant text-assistant hover:bg-assistant/20 duration-100"
      >
        <XMarkIcon className="size-4" />

        <span className="w-full">Kapat</span>
      </Button>
    </div>
  );
}
